export const AUTH_BOOTSTRAP_TIMEOUT_MS = 6000;
export const AUTH_BOOTSTRAP_ATTEMPTS = 2;
export const AUTH_BOOTSTRAP_RETRY_DELAY_MS = 500;
export const AUTH_RECOVERY_MAX_DELAY_MS = 5000;

const wait = (delayMs) => new Promise((resolve) => setTimeout(resolve, delayMs));

export const getAuthErrorStatus = (error) => Number(error?.response?.status || 0);

export const isTransientAuthError = (error) => {
  const status = getAuthErrorStatus(error);
  return status === 0 || status === 408 || status === 429 || status >= 500;
};

export const shouldClearSessionAfterAuthError = (error) => {
  const status = getAuthErrorStatus(error);
  return status === 401 || status === 403;
};

export const getAuthRecoveryDelayMs = (attempt) => (
  Math.min(AUTH_RECOVERY_MAX_DELAY_MS, 750 * (2 ** Math.max(0, Number(attempt) || 0)))
);

export const fetchCurrentUserWithRetry = async (
  client,
  {
    attempts = AUTH_BOOTSTRAP_ATTEMPTS,
    timeoutMs = AUTH_BOOTSTRAP_TIMEOUT_MS,
    retryDelayMs = AUTH_BOOTSTRAP_RETRY_DELAY_MS,
  } = {},
) => {
  let lastError;
  const totalAttempts = Math.max(1, attempts);

  for (let attempt = 1; attempt <= totalAttempts; attempt += 1) {
    try {
      return await client.get('/auth/me', { timeout: timeoutMs });
    } catch (error) {
      lastError = error;
      if (!isTransientAuthError(error) || attempt === totalAttempts) throw error;
      await wait(retryDelayMs);
    }
  }

  throw lastError;
};
